/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive} from '@angular/core';
/**
 * Prefix to be placed the the front of the form field.
 */
export class MdPrefix {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdPrefix], [matPrefix]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdPrefix_tsickle_Closure_declarations() {
/** @type {?} */
MdPrefix.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdPrefix.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
